export const REQUEST_ALL_CLIENTS_ACTION = 'REQUEST_ALL_CLIENTS_ACTION'
export const RECEIVE_ALL_CLIENTS_SUCCESS = 'RECEIVE_ALL_CLIENTS_SUCCESS'
export const RECEIVE_ALL_CLIENTS_FAILURE = 'RECEIVE_ALL_CLIENTS_FAILURE'
